import React from "react";
import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useIntl } from "react-intl";
import { AlertModal, type AlertModalProps } from "@packsize/components";

export interface ErrorModalProps extends Omit<AlertModalProps, "Icon" | "children" | "confirmText" | "onConfirm"> {
	readonly message: string;
	readonly onConfirm?: (e: React.UIEvent | undefined) => void | Promise<void>;
	readonly confirmText?: string;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({ message, onConfirm, size, confirmText, ...props }) => {
	const intl = useIntl();

	const handleConfirm = (e: React.UIEvent | undefined) => {
		if (onConfirm) {
			onConfirm(e);
			return;
		}

		props.onClose(e);
	};

	return (
		<AlertModal
			size={size || "sm"}
			Icon={ErrorOutlineIcon}
			onConfirm={handleConfirm}
			confirmText={confirmText || intl.formatMessage({ id: "Close", defaultMessage: "Close" })}
			{...props}
		>
			<Typography whiteSpace="pre-wrap">{message}</Typography>
		</AlertModal>
	);
};
